<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer004" role="doc-toc">
<p class="TOCtitle">Table of Contents</p>
<p class="TOCitem"><a href="#/Her_Cowboy_Reunion#_idContainer005">Her Cowboy Reunion</a> by Ruth Logan Herne</p>
<p class="TOCitem"><span href="#/Hill_Country_Reunion#_idContainer026" title="Link target outside of Sample">Hill Country Reunion</span> by Myra Johnson</p>
<p class="TOCitem">Excerpt from <span href="#/Excerpt#_idContainer048" title="Link target outside of Sample">The Prodigal Cowboy</span> by Brenda Minton</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_Contents.vue?0b92e249